"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.styles = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = require("@fluentui/react");

var _stylingConstants = require("../styling/stylingConstants");

var _selectors2;

var styles = {
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around'
  },
  rootContent: {
    maxHeight: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: 2 * _stylingConstants.gridUnit,
    boxSizing: 'border-box'
  },
  imageContainer: {
    maxHeight: _stylingConstants.gridUnit * 10,
    maxWidth: _stylingConstants.gridUnit * 10,
    fontSize: _stylingConstants.gridUnit * 8,
    lineHeight: _stylingConstants.gridUnit * 10,
    marginBottom: _stylingConstants.gridUnit * 3,
    margin: '0px auto',
    textAlign: 'center'
  },
  errorDetailsContainer: {
    display: 'flex',
    justifyContent: 'space-around'
  },
  detailComponent: {
    width: '50%',
    paddingTop: _stylingConstants.gridUnit * 1,
    selectors: (0, _defineProperty2.default)({}, "@media(max-width: ".concat(_react.ScreenWidthMaxSmall, "px)"), {
      width: '100%'
    })
  },
  errorDetails: {
    textAlign: 'center',
    position: 'relative'
  },
  titleText: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _react.DefaultFontStyles.xLarge), {}, {
    display: 'block'
  }),
  friendlyPromptText: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _react.DefaultFontStyles.medium), {}, {
    paddingBottom: _stylingConstants.gridUnit * 4,
    display: 'block'
  }),
  expandedView: {
    paddingTop: _stylingConstants.gridUnit * 4,
    position: 'relative',
    width: '95%',
    selectors: (_selectors2 = {}, (0, _defineProperty2.default)(_selectors2, "@media(min-width: ".concat(_react.ScreenWidthMinMedium, "px)"), {
      maxWidth: 650
    }), (0, _defineProperty2.default)(_selectors2, "@media(max-width: ".concat(_react.ScreenWidthMaxMedium, "px)"), {
      paddingLeft: _stylingConstants.gridUnit * 2,
      paddingRight: _stylingConstants.gridUnit * 2,
      boxSizing: 'border-box'
    }), _selectors2)
  },
  downloadButton: {
    position: 'absolute',
    top: _stylingConstants.gridUnit * 4,
    right: 0,
    background: 'none',
    minWidth: _stylingConstants.gridUnit * 4,
    padding: 0
  },
  toggleControls: {
    maxWidth: 250,
    margin: '0px auto'
  }
};
exports.styles = styles;